import React from 'react'
import { StyledQuestionnaireSelectForm, Props } from './styled'

export const QuestionnaireSelectForm: React.FC<Props> = (props: Props) => {
  return <StyledQuestionnaireSelectForm {...props} />
}
